import {
    getRxStorageLocalstorage
} from 'rxdb/plugins/storage-localstorage';
import { addRxPlugin, createRxDatabase } from 'rxdb/plugins/core';
import { RxDBDevModePlugin } from 'rxdb/plugins/dev-mode';
import { wrappedValidateAjvStorage } from 'rxdb/plugins/validate-ajv';
import { RxDBJsonDumpPlugin } from 'rxdb/plugins/json-dump';
import { v4 as uuidv4 } from 'uuid';
 
addRxPlugin(RxDBDevModePlugin);
addRxPlugin(RxDBJsonDumpPlugin);
 
let storage = getRxStorageLocalstorage();
storage = wrappedValidateAjvStorage({ storage });



export const db = await createRxDatabase({
  name: 'br-database',
  storage: storage
});

await db.addCollections({
    // name of the collection
    sessions: {
        // we use the JSON-schema standard
        schema: {
            version: 0,
            primaryKey: 'id',
            type: 'object',
            properties: {
                id: {
                    type: 'string',
                    maxLength: 100 // <- the primary key must have maxLength
                },
                result: {
                    type: 'string'
                },
                timestamp: {
                    type: 'string',
                    format: 'date-time'
                }
            },
            required: ['id', 'result', 'timestamp']
        }
    }
});

export const addResult = async (r) => {
    const ndoc = await db.sessions.insert( {
        id: uuidv4(),
        result: r,
        timestamp: new Date().toISOString()
    } );
    return ndoc;
}
export const getResults = async (tres) => {
    const now = new Date();
    const m = now.getMonth()+1;
    const mm = m<10 ? '0'+m : m;
    const d = now.getDate();
    const dd = d<10 ? '0'+d : d;
    const today = `2026-${mm}-${dd}T00:00:00.000Z`;
    console.log('check against',today);
    const results = await db.sessions.find({
        selector: {
            result: tres,
            timestamp: {
                $gte: today
            }
        }
    }).exec();
    return results;
}

export const exportStats = async () => {
    db.exportJSON()
        .then(json => {
            console.dir(json);
            const docs = json.collections[0].docs;

            const headers = Object.keys(docs[0]);
            const rows = docs.map( obj =>
                headers.map( header => {
                    const val = obj[header] === null || obj[header] === undefined ? '' : obj[header];
                    return `"${String(val).replace(/"/g, '""')}"`;
                }).join(',')
            );
            const content = [headers.join(','),...rows].join('\r\n');
            const filePath = `stats-${new Date().toISOString()}.csv`;

            const blob = new Blob([content],{type:'text/plain'});
            const fileUrl = URL.createObjectURL(blob);

            const dummylink = document.createElement('a');
            dummylink.href = fileUrl;
            dummylink.download = filePath;

            dummylink.click();

            URL.revokeObjectURL(fileUrl);
        });
}